"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PathType;
(function (PathType) {
    PathType["End"] = "end";
    PathType["Inner"] = "inner";
    PathType["Outer"] = "outer";
    PathType["Start"] = "start";
    PathType["Top"] = "top";
})(PathType = exports.PathType || (exports.PathType = {}));
